import styled from 'styled-components';

import {ReactComponent as CloseSVG} from '../assets/close.svg';

export const CloseIcon = styled(CloseSVG)`
  user-select: none;
  cursor: pointer;
  margin-right: 4px;
`;
export const PopupButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: #FFFF00;
    path {
      fill: #FFFF00;
    }
    rect {
      stroke: #FFFF00;
    }
  }
`;